import styled from 'styled-components';

const SpaceLabel = styled.label`
	display: flex;
	align-items: center;

	cursor: pointer;

	height: 40px;
	padding: 0 8px;
	margin-bottom: 8px;
	border-radius: 4px;

	&:hover {
		background-color: rgba(240,240,240,1);
	}

	input {
		margin-right: 8px;
	}

	span {
		background-color: ${props => props.theme.main};
		color: white;
    border-radius: 3px;
    padding: 4px 6px;
    font-size: 12px;
    margin-left: 4px;
	}
`;

export {
	SpaceLabel,
}
